import React from 'react'

export default function BandMeter({ bands = [], value = 0, unit = '£' }) {
  return (
    <div style={{ width: '100%', padding: '8px 0' }}>
      <div style={{ display: 'flex', height: 12, borderRadius: 6, overflow: 'hidden', background: '#f0f2f5', boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.03)' }}>
        {bands.map((b, i) => (
          <div key={i} title={b.label} style={{ width: `${b.widthPct}%`, background: b.color }} />
        ))}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6, fontSize: 12, color: '#666' }}>
        {bands.map((b, i) => (
          <div key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <span style={{ width: 10, height: 10, borderRadius: 2, background: b.color, display: 'inline-block' }} />
            <span>{b.label}</span>
          </div>
        ))}
      </div>
      {value > 0 && (
        <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>
          Indicative value: {unit}{value.toLocaleString()}
        </div>
      )}
    </div>
  )
}
